import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
} from "../util";

export const addDebtProjectToBusiness = ({
  businessId,
  vat_num,
  investee_name,
  country,
  share_of_costs,
  scope_1,
  scope_2,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = JSON.stringify({
    vat_num: vat_num,
    investee_name: investee_name,
    country: country,
    share_of_costs: share_of_costs,
    scope_1: scope_1,
    scope_2: scope_2,
    year: year,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/project",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage({});
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteDebtProject = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/project/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getDebtProjectList = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var config = {
    method: "get",
    url: baseUrl + "/api/business/project",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data.map((data) => {
          data.initial_investor = data.initial_investor ? "Yes" : "No";
          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const updateDebtProject = ({
  businessId,
  objectId,
  vat_num,
  investee_name,
  country,
  share_of_costs,
  scope_1,
  scope_2,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = JSON.stringify({
    vat_num: vat_num,
    investee_name: investee_name,
    country: country,
    share_of_costs: share_of_costs,
    scope_1: scope_1,
    scope_2: scope_2,
    year: year,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/project/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(response.data.data);
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      setErrorMessage(error.response.data);
    });
};

export const getDebtProject = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  setVatNumber = function () {
    return;
  },
  setInvesteeName = function () {
    return;
  },
  setCountryOrigin = function () {
    return;
  },
  setYourShare = function () {
    return;
  },
  setScope1 = function () {
    return;
  },
  setScope2 = function () {
    return;
  },
  setIsDataLoaded = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/project/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data);

      const gotValue = response.data.data;

      setVatNumber(gotValue.vat_num);
      setInvesteeName(gotValue.investee_name);
      setCountryOrigin(gotValue.country);
      setYourShare(gotValue.share_of_costs);
      setScope1(gotValue.scope_1);
      setScope2(gotValue.scope_2);
      setIsDataLoaded(true);
    })
    .catch(function (error) {
      console.log(error);
      setIsDataLoaded(true);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};
